/**
 * Landing v2 — "Stanna längre" accommodation section.
 * Subtle, editorial. Only renders when public accommodations exist.
 * Placed after Areas carousel, before Positioning.
 */
import { useLandingAccommodations } from "@/hooks/usePublicAccommodations";
import { AccommodationSection } from "@/components/public/AccommodationSection";
import { useTranslate } from "@/i18n";

export default function LandingAccommodationSection() {
  const { data: accommodations = [], isLoading } = useLandingAccommodations(3);
  const t = useTranslate();

  if (isLoading || accommodations.length === 0) return null;

  return (
    <section className="py-16 sm:py-24">
      <div className="container max-w-6xl px-5">
        <p className="text-xs tracking-widest uppercase text-muted-foreground/60 mb-2">
          {t("home.accommodation.kicker")}
        </p>
        <h2 className="font-display text-2xl sm:text-3xl font-semibold text-foreground tracking-[-0.015em] leading-[1.15] mb-3">
          {t("home.accommodation.title")}
        </h2>
        <p className="text-base text-muted-foreground leading-relaxed mb-8 sm:mb-10 max-w-lg">
          {t("home.accommodation.sub")}
        </p>

        <AccommodationSection
          accommodations={accommodations}
          title=""
          getContext={(acc) => acc.producer_name || null}
        />
      </div>
    </section>
  );
}
